module.exports = __webpack_public_path__ + "img/example.dc4abb8c.png";